import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalEventsService {
  #registeredEvents: { [eventName: string]: Subject<Event> } = {};
  #renderer: Renderer2 = inject(RendererFactory2).createRenderer(null, null);

  listenEvent(eventName: string): Observable<Event> {
    if (this.#registeredEvents[eventName]) {
      return this.#registeredEvents[eventName].asObservable();
    }

    this.#registeredEvents[eventName] = new Subject();
    const [context, event] = eventName.split(':');
    this.#renderer.listen(context, event, (evt) => {
      this.#registeredEvents[eventName].next(evt);
    });
    return this.#registeredEvents[eventName].asObservable();
  }
}
